import React from 'react';
import { observer } from 'mobx-react';
import DefaultButton from '../../../global/default-button/default-button';
import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { IEventLinkDTO } from '../../../../api/event-links.dao';
import { CreateEventLinkType, EventLinksViewModel } from '../../../_events/_manage-event/shared/event-links/event-links.viewmodel';
import { EventLinkForm } from '../../../_events/_manage-event/shared/event-links/event-link-form/event-link-form';
import { EventLinkFormViewModel } from '../../../_events/_manage-event/shared/event-links/event-link-form/event-link-form.viewmodel';
import { addText, cancelText } from '../../../../constants/common-labels.constants';

type ContainerProps = {
    links: IEventLinkDTO[];
    accountId: number;
    eventId: number;
    isEventTrackerForm?: boolean;
    fetchEventsList: () => Promise<void>;
    closeAddLinksPopup: () => void;
};

type Props = {
    vm: EventLinksViewModel;
};

export const EventTrackerAddLinksView = observer((props: Props): JSX.Element => {
    const { vm } = props;

    const formProps = {
        types: vm.linkTypes
    };

    const formVM = EventLinkFormViewModel.create(formProps);

     const addEventLink = async (): Promise<void> => {
        await vm.onAddEventLink(formVM.getFormFields() as CreateEventLinkType);
        await vm.fetchEventsList();
    };

    const onApply = (): void | null => {
        if (!formVM.isVmValid()) {
            formVM.setVmTouched();
            return null;
        }
        addEventLink();
    };

    return (
            <div className='event-link-form-in-popover'>
                <EventLinkForm vm={formVM} />
                <div className='oe-popup-layout__footer'>
                    <div className='buttons-block buttons-block--from-right'>
                            <DefaultButton
                                text={addText()}
                                modifier={['fat', 'confirm-safe']}
                                onClick={onApply}
                            />
                            <DefaultButton
                                text={cancelText()}
                                modifier='cancel'
                                onClick={vm.closeAddLinksPopup}
                            />
                        </div>
                </div>
            </div>
    );
});

const EventTrackerAddLinksContainer = withViewModel(EventTrackerAddLinksView, async (props: ContainerProps) => {
    const vm = new EventLinksViewModel(props);
    await vm.initialize();
    return vm;
},
);
export { EventTrackerAddLinksContainer as EventTrackerAddLinks };
